export const termsOfUse = `# Terms of Use

Last updated: ${new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}

Please read these Terms of Use ("Terms") carefully before using the Alchemist web portal.

## 1. Acceptance of Terms

By accessing or using the Alchemist web portal ("Service"), you agree to be bound by these Terms. If you do not agree to these Terms, do not use the Service.

## 2. Definitions

- **"Service"** means the Alchemist web portal and all related services provided by Tier One Analytics, Inc.
- **"Company"** (referred to as "we", "us", or "our") means Tier One Analytics, Inc., 1751 Pinnacle Dr #600 McLean VA 22102 USA.
- **"You"** means the individual or entity accessing or using the Service.
- **"Content"** means any files, data, or information you upload to or process through the Service.

## 3. Service Description

Alchemist is a cloud-based data analysis and conversion service. You may upload files for analysis and conversion, and download the resulting artifacts.

## 4. Use of Service

### 4.1 Eligibility
You must be at least 18 years old and have the legal capacity to enter into these Terms.

### 4.2 Account Responsibilities
- You are responsible for maintaining the confidentiality of your account credentials
- You are responsible for all activities that occur under your account
- You must notify us immediately of any unauthorized use

### 4.3 Acceptable Use
You agree not to:
- Use the Service for any illegal or unauthorized purpose
- Upload malicious code or content that could harm the Service
- Attempt to gain unauthorized access to any part of the Service
- Reverse engineer or attempt to extract the source code of the Service
- Use the Service to process data you don't have the right to process
- Resell or redistribute the Service without our written consent

## 5. Content and Data

### 5.1 Your Content
- You retain all rights to the Content you upload
- You grant us a limited license to process your Content solely to provide the Service
- You represent that you have all necessary rights to upload and process the Content

### 5.2 Data Processing
- Content is encrypted during transfer and at rest
- Content is temporarily stored only during analysis
- Analysis artifacts are stored encrypted until you delete them

## 6. Intellectual Property

The Service and its original content, features, and functionality are owned by the Company and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.

## 7. Privacy

Your use of the Service is also governed by our Privacy Policy. Please review our Privacy Policy, which also governs the Service and informs users of our data collection practices.

## 8. Disclaimers

THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.

## 9. Limitation of Liability

TO THE MAXIMUM EXTENT PERMITTED BY LAW, THE COMPANY SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES.

## 10. Indemnification

You agree to indemnify and hold harmless the Company and its officers, directors, employees, and agents from any claims, damages, or expenses arising from your use of the Service or violation of these Terms.

## 11. Modifications to Service

We reserve the right to modify or discontinue the Service at any time without notice. We shall not be liable to you or any third party for any modification, suspension, or discontinuance of the Service.

## 12. Termination

We may terminate or suspend your access to the Service immediately, without prior notice or liability, for any reason, including breach of these Terms.

## 13. Governing Law

These Terms shall be governed by and construed in accordance with the laws of Virginia, United States, without regard to its conflict of law provisions.

## 14. Changes to Terms

We reserve the right to modify these Terms at any time. If we make material changes, we will notify you by updating the date at the top of these Terms.

## 15. Contact Information

If you have any questions about these Terms, please contact us at:
- Email: office@getalchemist.io
- Website: https://getalchemist.io

By using the Service, you acknowledge that you have read, understood, and agree to be bound by these Terms of Use.`;